import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18n, { isRtlLang } from './i18n';
import './index.css';

const App: React.FC = () => {
  const { t } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState<string>(
    localStorage.getItem('language') || 'ar'
  );

  useEffect(() => {
    i18n.changeLanguage(currentLanguage);
    document.documentElement.dir = isRtlLang(currentLanguage) ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLanguage;
    localStorage.setItem('language', currentLanguage);
  }, [currentLanguage]);

  const toggleLanguage = (lang: string) => {
    setCurrentLanguage(lang);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header
            currentLanguage={currentLanguage}
            toggleLanguage={toggleLanguage}
          />
          <main className="flex-grow">
            <Routes>
              <Route
                path="/"
                element={<HomePage />}
              />
              <Route
                path="/services"
                element={<ServicesPage />}
              />
              <Route
                path="/about"
                element={<AboutPage />}
              />
              <Route
                path="/contact"
                element={<ContactPage />}
              />
            </Routes>
            {/* WhatsApp Button */}
            <div className="fixed bottom-8 right-8 z-50 max-h-[55px] w-[55px] md:max-h-[70px] md:w-[70px] rounded-full overflow-hidden flex items-center justify-center">
              <a
                href="https://wa.me/971503534324"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-green-600/70 to-green-600/60 hover:from-green-700 hover:to-green-700 text-white p-8 flex items-center justify-center"
                title={t('header.whatsup')}
              >
                <i className="fab fa-whatsapp text-2xl md:text-3xl"></i>
              </a>
            </div>
          </main>
          <Footer />
        </div>
      </Router>
    </I18nextProvider>
  );
};

export default App;
